// ==========================================
// src/styles/theme.ts - IMPROVED VERSION
// ==========================================
export const theme = {
  colors: {
    primary: '#1a3a52',
    secondary: '#d4a574',
    accent: '#8b7355',
    light: '#f8f6f3',
    dark: '#2c2c2c',
    white: '#ffffff',
    black: '#000000',
    gray: {
      100: '#f7fafc',
      200: '#edf2f7',
      300: '#e2e8f0',
      400: '#cbd5e0',
      500: '#a0aec0',
      600: '#718096',
      700: '#4a5568',
      800: '#2d3748',
      900: '#1a202c',
    },
    gradient: {
      primary: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      secondary: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      sunset: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
      ocean: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    }
  },
  
  fonts: {
    primary: "'Playfair Display', serif",
    secondary: "'Inter', sans-serif",
    mono: "'Fira Code', monospace",
  },
  
  // NEW: Comprehensive typography system
  typography: {
    // Font sizes with better scaling
    fontSize: {
      xs: '0.75rem',      // 12px
      sm: '0.875rem',     // 14px
      base: '1.125rem',   // 18px (improved from 16px)
      md: '1rem',         // 16px
      lg: '1.25rem',      // 20px
      xl: '1.5rem',       // 24px
      '2xl': '2rem',      // 32px
      '3xl': '2.5rem',    // 40px
      '4xl': '3.5rem',    // 56px
      '5xl': '4.5rem',    // 72px
      '6xl': '6rem',      // 96px
    },
    
    // Line heights for different contexts
    lineHeight: {
      none: '1',
      tight: '1.25',
      snug: '1.375',
      normal: '1.6',
      relaxed: '1.75',    // Better for body text
      loose: '2',
    },
    
    // Font weights
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900,
    },
    
    // Letter spacing
    letterSpacing: {
      tighter: '-0.05em',
      tight: '-0.025em',
      normal: '0',
      wide: '0.025em',
      wider: '0.05em',
      widest: '0.1em',
    },
    
    // Heading scale (responsive with clamp)
    headings: {
      h1: {
        fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',    // 40-72px
        lineHeight: '1.1',
        fontWeight: '700',
        letterSpacing: '-0.025em',
      },
      h2: {
        fontSize: 'clamp(2rem, 4vw, 3.5rem)',      // 32-56px
        lineHeight: '1.2',
        fontWeight: '700',
        letterSpacing: '-0.02em',
      },
      h3: {
        fontSize: 'clamp(1.5rem, 3vw, 2.5rem)',    // 24-40px
        lineHeight: '1.3',
        fontWeight: '600',
        letterSpacing: '0',
      },
      h4: {
        fontSize: 'clamp(1.25rem, 2vw, 1.75rem)',  // 20-28px
        lineHeight: '1.4',
        fontWeight: '600',
        letterSpacing: '0',
      },
      h5: {
        fontSize: '1.125rem',                       // 18px
        lineHeight: '1.5',
        fontWeight: '600',
        letterSpacing: '0',
      },
      h6: {
        fontSize: '1rem',                           // 16px
        lineHeight: '1.5',
        fontWeight: '600',
        letterSpacing: '0',
      },
    },
  },
  
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
    xxl: '1440px',
  },
  
  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '4rem',
  },
  
  transitions: {
    fast: '0.2s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 6px rgba(0, 0, 0, 0.1)',
    large: '0 10px 15px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px rgba(0, 0, 0, 0.1)',
    xxl: '0 25px 50px rgba(0, 0, 0, 0.15)',
  },
};